module.exports = __webpack_public_path__ + "static/media/full_4.05cd6a6e.jpg";